<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить учёные степени лица</span>
              <span v-else> <div>Создать учёные степени лица</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-autocomplete
              :error="hasError('dissertationCouncil')"
              :error-messages="getError('dissertationCouncil')"
              :items="selectors.dissertationCouncil"
              label="Диссертационный совет"
              v-model="value.dissertationCouncil"
              no-data-text ="Нет данных"
            ></v-autocomplete>

            <v-autocomplete
              :error="hasError('scientificField')"
              :error-messages="getError('scientificField')"
              :items="selectors.scientificField"
              label="Научная специальность (по отраслям науки)"
              v-model="value.scientificField"
              no-data-text ="Нет данных"
            ></v-autocomplete>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    import urls from "../../../../../modules/petition/urls.js"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import {makeGetRequest} from "../../../../../helper";

    export default {
        name: "Dissertation_council_scientific_field.vue",
        mixins: [UserDataFormMixin],
        props: ['id','info','scientificField','dissertationCouncil'],

        data() {
            return {
                URL_CREATE: urls.getUrl('admin|diss|models|dissertation_council_scientific_field-list', 'list'),
                URL_UPDATE:  urls.getUrl('admin|diss|models|dissertation_council_scientific_field-detail', 'destroy'),
                selectors:{
                    scientificField:[],
                    dissertationCouncil:[]
                },
                value: {
                    id: this.id || '',
                    scientificField: this.scientificField || null,
                    dissertationCouncil: this.dissertationCouncil || null,
                },
                // errors: {}
            }
        },

        methods: {
            closeDialog() {
                this.$emit('ended', '')
            },

            loadSelector(data, url) {
                let sys = true
                makeGetRequest(url).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.selectors[data] = json
                })
            },

            text: item => item.name[0].text,

        },
        created() {
            if(this.$props.info !== undefined)
                this.value.dissertationCouncil = this.$props.info
            let url =  process.env.VUE_APP_API_HOST +"council/admin/core/selectors/scientific_field/"
            this.loadSelector('scientificField',url)

            url =  process.env.VUE_APP_API_HOST +"council/admin/diss/selectors/dissertation_council/"
            this.loadSelector('dissertationCouncil',url)

        }
    }

</script>

<style scoped>

</style>
